import { ApiClient } from '../utils/api-client'
import { BCAUploadResponse, BCAHistoryResponse, SMIHistoryResponse } from '../types'

const API_CONFIG = {
  baseURL: process.env.REACT_APP_API_FOODBOT_BASE_URL || 'https://tatva-food-bot-uat.mytatva.in',
  headers: {
    'Accept': 'application/json'
  }
}

const apiClient = new ApiClient(API_CONFIG)

export const bcaService = {
  async uploadBCAReport(userId: string, file: File): Promise<BCAUploadResponse> {
    try {
      // Prepare form data for the API
      const formData = new FormData()
      formData.append('user_id', userId)
      formData.append('file', file)

      const response = await apiClient.post<string[]>(
        '/bca_bot',
        formData,
        {
          requireAuth: false
        }
      )

      // Check if the response indicates success
      if (response.data && Array.isArray(response.data) && response.data[0] === "Thankyou your data has been saved") {
        return {
          message: response.data[0]
        }
      } else {
        throw new Error('Unexpected response format')
      }
    } catch (error: any) {
      console.error('BCA Upload API Error:', error)
      throw new Error(error.message || 'Failed to upload BCA report')
    }
  },

  async getBCAHistory(userId: string, page: number = 1, limit: number = 10): Promise<BCAHistoryResponse> {
    try {
      const response = await apiClient.get<BCAHistoryResponse>(
        '/bca/history',
        {
          params: {
            user_id: userId,
            page,
            limit
          },
          requireAuth: false
        }
      )

      return response.data
    } catch (error: any) {
      console.error('BCA History API Error:', error)
      throw new Error(error.message || 'Failed to fetch BCA history')
    }
  },

  async getSMIHistory(userId: string, page: number = 1, limit: number = 10): Promise<SMIHistoryResponse> {
    try {
      const response = await apiClient.get<SMIHistoryResponse>(
        '/smi',
        {
          params: {
            user_id: userId,
            page,
            limit
          },
          requireAuth: false
        }
      )

      return response.data
    } catch (error: any) {
      console.error('SMI History API Error:', error)
      throw new Error(error.message || 'Failed to fetch SMI history')
    }
  },

  async deleteBCALog(userId: string, logId: string): Promise<void> {
    try {
      await apiClient.delete(
        '/bca/history',
        {
          params: {
            user_id: userId,
            log_id: logId
          },
          requireAuth: false
        }
      )
    } catch (error: any) {
      console.error('Delete BCA Log API Error:', error)
      throw new Error(error.message || 'Failed to delete BCA log')
    }
  }
} 